import { useSuspenseQuery } from '@tanstack/react-query';
import { cartService, goodsService } from 'shared/src/api';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { queryKey } from '../../../constant/queryKey';
import { convertGoodsLikeItemToGoodsData } from '../utils/convertGoodsLikeItemToGoodsData';
import { usePostGoodsActionMode } from '../context/PostGoodsActionContext';

export const useGoodsLikeRecommend = () => {
  const goodsSno = useGoodsSno();
  const mode = usePostGoodsActionMode();

  return useSuspenseQuery({
    queryKey: queryKey.goodsLikeRecommend(goodsSno, mode),
    queryFn: () => {
      if (mode === 'cart') {
        return cartService.getAddCartRecommend(goodsSno);
      }
      return goodsService.getGoodsLikeRecommend(goodsSno);
    },
    select: data => {
      return {
        ...data,
        carousels: data.carousels.map(carousel => {
          return {
            ...carousel,
            item_list: carousel.item_list.map(convertGoodsLikeItemToGoodsData),
          };
        }),
      };
    },
  });
};
